import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-pay-stubs-data-grid',
  templateUrl: './pay-stubs-data-grid.component.html',
  styleUrls: ['./pay-stubs-data-grid.component.scss']
})
export class PayStubsDataGridComponent implements OnInit {
  public gridData: any[] = [
    {
      payDate: 'July 1, 2021',
      totalGrossPay: '$3,653.85',
      taxes: '$934.70',
      deductions: '$185.62',
      netAmount: '$2,533.53',
      ytdNet: '$23,386.69',
    },
    {
      payDate: 'June 28, 2021',
      totalGrossPay: '$3,653.85',
      taxes: '$934.70',
      deductions: '$185.62',
      netAmount: '$2,533.53',
      ytdNet: '$20,853.16',
    },
    {
      payDate: 'June 4, 2021',
      totalGrossPay: '$3,653.85',
      taxes: '$934.70',
      deductions: '$185.62',
      netAmount: '$2,533.53',
      ytdNet: '$18,319.63',
    },
  ];

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  openPdfViewerDialog() {
    window.open('/assets/adp-paystub-sample.pdf', '_blank');
  }

}
